import { formatCopy } from "../../../theme/copy";
import VisibilityOutlined from "@mui/icons-material/VisibilityOutlined";
import { Box, IconButton } from "@mui/material";
import React from "react";
import { useThemeContext } from "../../../globalContext/global-context";
import { PreviewImageWrapperProps } from "../../../util/types";

export const PreviewImageButton = ({
  imageToPreview,
  altText,
  sourceCanvas,
  setOverRideSelect,
}: {
  imageToPreview: string;
  altText?: string;
  sourceCanvas?: HTMLCanvasElement;
  setOverRideSelect?: (value: boolean) => void;
}) => {
  const { globalObject, previewImageEventTrigger } = useThemeContext();
  const theme = globalObject.themeData.normalizedTheme;
  const colors = theme.tokens.color;
  return (
    <IconButton
      className="preview-icon"
      aria-label={formatCopy(theme.copy.labels.preview, {
        image: altText || theme.copy.labels.image,
      })}
      onClick={(event) => {
        event.stopPropagation();
        previewImageEventTrigger(
          imageToPreview,
          true,
          undefined,
          sourceCanvas,
          altText,
        );
      }}
      onMouseEnter={() => setOverRideSelect?.(true)}
      onMouseLeave={() => setOverRideSelect?.(false)}
      onFocus={() => setOverRideSelect?.(true)}
      onBlur={() => setOverRideSelect?.(false)}
      sx={{
        position: "absolute",
        top: 5,
        right: 2,
        backgroundColor: colors.surface.overlay,
        color: colors.text.inverse,
        padding: "4px",
        zIndex: 1,
      }}
      data-testid="preview-icon"
    >
      <VisibilityOutlined sx={{ fontSize: { sm: 14, xs: 8 } }} />
    </IconButton>
  );
};

const PreviewImageWrapper: React.FC<PreviewImageWrapperProps> = ({
  ImageBox,
  setOverRideSelect,
  imageToPreview,
  altText,
  sourceCanvasRef,
  fillContainer = false,
}) => {
  return (
    <Box
      data-testid="preview-image-wrapper"
      sx={{
        position: "relative",
        display: "flex",
        width: "100%",
        ...(fillContainer
          ? {
              height: "100%",
              minHeight: 0,
              alignItems: "center",
              justifyContent: "center",
            }
          : {}),
        "& .preview-icon": { opacity: 0 },
        "&:hover .preview-icon, &:focus-within .preview-icon": { opacity: 1 },
        "@media (hover: none)": { "& .preview-icon": { opacity: 1 } },
      }}
      onContextMenu={(event) => event.preventDefault()}
      onDragStart={(event) => event.preventDefault()}
    >
      {ImageBox}
      <PreviewImageButton
        imageToPreview={imageToPreview}
        altText={altText}
        sourceCanvas={sourceCanvasRef.current ?? undefined}
        setOverRideSelect={setOverRideSelect}
      />
    </Box>
  );
};

export default PreviewImageWrapper;
